var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_18",
    "data-name": "Rect\\xE1ngulo 18",
    width: 18.373,
    height: 18.374,
    transform: "translate(0 0)",
    fill: "white"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_30",
    "data-name": "Rect\\xE1ngulo 30",
    width: 24,
    height: 24,
    fill: "whitw",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_35",
    "data-name": "Grupo 35",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_34",
    "data-name": "Grupo 34",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_29",
    "data-name": "Trazado 29",
    d: "M15.623,0H2.75A2.752,2.752,0,0,0,0,2.75V15.624a2.752,2.752,0,0,0,2.75,2.75H15.623a2.752,2.752,0,0,0,2.75-2.75V2.75A2.752,2.752,0,0,0,15.623,0m1.25,2.75V15.624a1.252,1.252,0,0,1-1.25,1.25H2.75a1.251,1.251,0,0,1-1.25-1.25V2.75A1.251,1.251,0,0,1,2.75,1.5H15.623a1.252,1.252,0,0,1,1.25,1.25",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30",
    "data-name": "Trazado 30",
    d: "M9.186,4.342a4.845,4.845,0,1,0,4.845,4.845A4.85,4.85,0,0,0,9.186,4.342m3.345,4.845A3.345,3.345,0,1,1,9.186,5.842a3.349,3.349,0,0,1,3.345,3.345",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31",
    "data-name": "Trazado 31",
    d: "M14.387,2.941a1.075,1.075,0,1,0,1.075,1.075,1.075,1.075,0,0,0-1.075-1.075",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.903f4e4732112101501b438ac930c82a.svg";
export { ForwardRef as ReactComponent };